/* eslint-disable @angular-eslint/directive-selector */
import { Directive, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { ResizeObserver } from 'resize-observer';

@Directive({ selector: '[shadowScroll]' })
export class ShadowScrollDirective implements OnInit, OnDestroy {
  private host = this.el.nativeElement as HTMLElement;
  private hostParent = this.host?.parentElement as HTMLElement;
  private resizeObserver!: ResizeObserver;

  constructor(private el: ElementRef) {}

  ngOnInit(): void {
    if (this.hostParent) {
      this.hostParent.classList.add('shadow-scroll');

      this.resizeObserver = new ResizeObserver(this.checkIsScrollEnabled);
      this.resizeObserver.observe(this.host);
      this.resizeObserver.observe(this.hostParent);
    }
  }

  ngOnDestroy(): void {
    if (this.resizeObserver) {
      this.hostParent.classList.remove('shadow-scroll');

      this.resizeObserver.unobserve(this.host);
      this.resizeObserver.unobserve(this.hostParent);
      this.resizeObserver.disconnect();
    }
  }

  private checkIsScrollEnabled = () => {
    if (
      this.host.offsetHeight >
      this.hostParent.offsetHeight - this.getPseudoMaskHeight()
    ) {
      this.hostParent.classList.add('shadow-scroll-enable');
    } else {
      this.hostParent.classList.remove('shadow-scroll-enable');
    }
  };

  private getPseudoMaskHeight(): number {
    if (!this.hostParent) {
      return 0;
    }
    const pseudoElementStyle = getComputedStyle(this.hostParent, '::before');
    const height = pseudoElementStyle?.height;
    if (!height) {
      return 0;
    }
    const maskHeight = parseFloat(height);
    if (isNaN(maskHeight)) {
      return 0;
    }
    return maskHeight;
  }
}
